"use client";

import { useEffect } from "react";
import { useIsomorphicLayoutEffect } from "react-use";
import { useGSAP } from "@gsap/react";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

export const GSAPRegister = () => {
    useIsomorphicLayoutEffect(() => {
        gsap.registerPlugin(ScrollTrigger, useGSAP);
    }, []);

    useEffect(() => {
        const observer = new ResizeObserver(() => {
            ScrollTrigger.refresh();
        });

        observer.observe(document.body);

        return () => {
            observer.disconnect();
        };
    }, []);

    return null;
};
